import { useRepayDialog } from './logic/useRepayDialog'
import { RepayView } from './views/RepayView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { Reserve } from '@/features/sparklend/common/data/market-info/marketInfo'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface RepayDialogContentContainerProps {
  reserve: Reserve
  initialRepayToken: SparkLendToken
  closeDialog: () => void
}

function RepayDialogContentContainer({ reserve, initialRepayToken, closeDialog }: RepayDialogContentContainerProps) {
  const {
    dialogTitle,
    repayOptions,
    assetsToRepayFields,
    pageStatus,
    form,
    repayAsset,
    inputAsset,
    currentPositionOverview,
    updatedPositionOverview,
    actionsViewState,
  } = useRepayDialog({ reserve, initialRepayToken })

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        inputAsset={inputAsset}
        repayAsset={repayAsset}
        onProceed={closeDialog}
        proceedText="View in portfolio"
      />
    )
  }

  return (
    <RepayView
      dialogTitle={dialogTitle}
      debtAsset={repayAsset.token}
      repayOptions={repayOptions}
      actionsViewState={actionsViewState}
      form={form}
      assetsToRepayFields={assetsToRepayFields}
      currentPositionOverview={currentPositionOverview}
      updatedPositionOverview={updatedPositionOverview}
    />
  )
}

const RepayDialogContentContainerWithSuspense = withSuspense(RepayDialogContentContainer, DialogContentSkeleton)
export { RepayDialogContentContainerWithSuspense as RepayDialogContentContainer }
